<div class="new-comers-area ptb-100">
    <div class="container">
        <div class="row align-items-center">
            <div class="col-lg-6 col-md-12">
                <div class="new-comers-image">
                    <img id="about-image" src="assets/images/new/mission/mission_1.svg" width="600" height="600" alt="image">
                </div>
            </div>
            <div class="col-lg-6 col-md-12">
                <div class="new-comers-content">
                    <h3>Notre mission</h3>  
                    <h4 class="dash"></h4>
                    <p class="mission-text">Offrir, par le professionnalisme et le dévouement de nos équipes,
                         des solutions dynamiques et innovantes en éducation, formation et
                          coaching, en vue de fournir au client, COMPETENCES, MÉCANISME et
                           MODELE et participant ainsi au développement social,
                         économique des personnes, des organisations et des communautés.</p>
                    <div class="new-comers-btn">
                        <a routerLink="/about-style-1" class="default-btn abt-btn">
                            <i class='bx bx-move-horizontal icon-arrow before'></i>
                            <span class="label">J'inscris mon enfant</span>
                            <i class="bx bx-move-horizontal icon-arrow after"></i>
                        </a>
                    </div>
                    <!-- <blockquote class="wp-block-quote">
                        <p style="text-align: justify;" > « L'éducation est plus qu'un métier, c'est une mission, qui consiste à aider chaque personne à reconnaitre ce qu'elle a d'irremplaçable et d'unique, afin qu'elle grandisse et s'épanouisse. »</p>
                        <i style="position: absolute; right: 0; color: #ff6e1c; padding-bottom: 10px">Pape Saint Jean Paul II</i>
                    </blockquote> -->
                </div>
            </div>
        </div>

        <div class="row align-items-center mt-4 pt-2">
            <div class="col-lg-6 col-md-12">
                <div class="new-comers-content">
                    <h3>Une nouvelle manière d'apprendre</h3>  
                    <h4 class="dash">.</h4>
                    <p class="mission-text">Au C.A.C.E. Ste Louise de Siméon, nous plaçons <b>l'éducation au cœur du développement 
                        personnel et collectif</b>. Un apprentissage équilibré et de qualité est essentiel pour bâtir un avenir solide.
                        C'est pourquoi nous avons conçu un <b>environnement stimulant</b>, encadré par des professionnels passionnés, pour
                         transmettre aux enfants non seulement des connaissances, mais aussi des valeurs et des méthodes d’apprentissage
                          adaptées à leur épanouissement.</p>
                    <div class="new-comers-btn">
                        <a routerLink="/about-style-1" class="default-btn">
                            <i class='bx bx-move-horizontal icon-arrow before'></i>
                            <span class="label">En savoir plus</span>
                            <i class="bx bx-move-horizontal icon-arrow after"></i>
                        </a>
                    </div>
                    <!-- <blockquote class="wp-block-quote">
                        <p style="text-align: justify;" > « L'éducation est plus qu'un métier, c'est une mission, qui consiste à aider chaque personne à reconnaitre ce qu'elle a d'irremplaçable et d'unique, afin qu'elle grandisse et s'épanouisse. »</p>
                        <i style="position: absolute; right: 0; color: #ff6e1c; padding-bottom: 10px">Pape Saint Jean Paul II</i>
                    </blockquote> -->
                </div>
            </div>
            <div class="col-lg-6 col-md-12 mt-4">
                <div class="new-comers-image">
                    <img id="about-image" src="assets/images/new/mission/mission_2.svg" width="600" height="600" alt="image">
                </div>
            </div>
        </div>
    </div>
</div>
<!-- Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. -->